import PaneelNavigatie from "../../components/Paneel/paneelNavigatie";

import { useState } from "react";
import config from "../../config";
import { useEffect } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import { check_login } from "../../auth/auth";
import { check_permission } from "../../auth/auth";
import { Link } from "react-router-dom";
function Paneel_Home() {
    const [claims] = useState(check_login(true));
    const [allowed] = useState(check_permission("praesidium", true));

    const [counters, setCounters] = useState({
        praesidium: 0,
        events: 0
    });

    useEffect(() => {
        let data = { praesidium: 0, events: 0 };
        axios.get(config.api_url + "/praesidia/?active=true").then((response) => {
            data = { ...data, praesidium: response.data.data[0].praesidium?.length };
            setCounters(data);
        });
        axios.get(config.api_url + "/events/").then((response) => {
            data = { ...data, events: response.data.meta.size };
            setCounters(data);
        });
    }, []);
    return (
        <>
            {claims && allowed && (
                <>
                    <div className="dark:bg-zinc-900">
                        <PaneelNavigatie />
                        <Helmet>
                            <title>Paneel - Home - Hermes Gent</title>
                            <meta name="description" content="Hermes Gent Cursusverkoop" />
                        </Helmet>
                        <div className="lg:w-8/12 w-11/12 pt-20 pb-40 mx-auto">
                            <h1 className="font-extrabold text-2xl md:text-3xl xl:text-4xl text-gray-700 dark:text-gray-300 mb-10">PRAESIDIUM PANEEL</h1>

                            <div className="grid gap-8 md:grid-cols-2">
                                <Link to={"/paneel/praesidium"} className="shadow-md border border-zinc-200 p-12 rounded-lg dark:bg-black/40 dark:border-zinc-800 transition-transform hover:scale-110">
                                    <h1 className="font-extrabold text-2xl md:text-3xl xl:text-4xl text-gray-700 dark:text-gray-300 mb-10 text-center">
                                        PRAESIDIUMLEDEN
                                        <p className="mt-8 text-8xl">{counters.praesidium}</p>
                                    </h1>
                                </Link>
                                <Link to={"/paneel/events"} className="shadow-md border border-zinc-200 p-12 rounded-lg dark:bg-black/40 dark:border-zinc-800 transition-transform hover:scale-110">
                                    <h1 className="font-extrabold text-2xl md:text-3xl xl:text-4xl text-gray-700 dark:text-gray-300 mb-10 text-center">
                                        EVENTS
                                        <p className="mt-8 text-8xl">{counters.events}</p>
                                    </h1>
                                </Link>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default Paneel_Home;
